<div>
  <app-tertiary-button
    [leftIconSrc]="iconSrc$ | async"
    [disabled]="disabled"
    [size]="BaseButtonSizeEnum.md"
    (buttonClicked)="clicked.emit()">
    {{ buttonText$ | async }}
  </app-tertiary-button>
</div>
